import { AddFoodBottomsheetComponent } from './../../add-food-bottomsheet/add-food-bottomsheet.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { SnackBarService } from './../../../../data/repository/utils-repository/snack-bar.service';
import { TextHelper } from './../../../../utils/text-helper';
import { PlanService } from './../../../../data/repository/plan-repository/plan.service';
import { Component, OnInit, Input, Output, OnDestroy } from '@angular/core';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import { EventEmitter } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DietSearchedFoodModel } from 'src/app/core/model/object/diet-model';

@Component({
  selector: 'app-personal-package-search',
  templateUrl: './personal-package-search.component.html',
  styleUrls: ['./personal-package-search.component.scss'],
})
export class PersonalPackageSearchComponent implements OnInit, OnDestroy {
  @Input() show = false;
  @Output() closeSearch: EventEmitter<boolean> = new EventEmitter(false);
  searchText: string;
  showLoading: boolean = false;
  searchedFoods: DietSearchedFoodModel[];
  txtQueryChanged: Subject<string> = new Subject<string>();
  isEmpty: boolean = false;
  Subscriptions: Subscription[] = [];

  constructor(
    private planService: PlanService,
    private textHelper: TextHelper,
    private snackBarService: SnackBarService,
    private matBottomSheet: MatBottomSheet
  ) {
    const txtq = this.txtQueryChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((model) => {
        this.searchText = model;
        this.searchQ(model);
      });
    this.Subscriptions.push(txtq);
  }

  ngOnInit() {}
  ngOnDestroy() {
    this.Subscriptions.forEach((sb) => sb.unsubscribe());
  }
  back() {
    this.closeSearch.emit(true);
  }
  searchQ(text: string) {
    if (this.searchText && this.searchText !== '') {
      this.isEmpty = false;
      this.showLoading = true;
      this.planService
        .findFood(
          this.textHelper.replaceArabicLettersWithPersian(this.searchText)
        )
        .then(async (res) => {
          if (text === this.searchText) {
            this.searchedFoods = [];
            if (res.isSuccess()) {
              this.showLoading = false;

              const search = await res.getData().getSearchedFoods();

              this.searchedFoods = await search.sort((a, b) =>
                a.name.localeCompare(b.name)
              );
            } else {
              this.showLoading = false;

              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
          }
        })
        .catch((c) => (this.isEmpty = true));
    } else {
      this.searchedFoods = [];
    }
  }
  search(query: string) {
    query = query.trim();
    if (query.length <= 0) {
      this.searchText = '';
    } else {
      this.txtQueryChanged.next(query);
    }
  }
  async openFood(id: string) {
    const food = await this.planService.getFoodDeatailByDb(id);
    this.matBottomSheet.open(AddFoodBottomsheetComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        food: food,
        isCreatePerosnalPackage: true,
      },
    });
  }
  clearSearchText() {
    this.searchText = '';
  }
}
